// Lightweight browser push helper. Real, immediate alerts while the app is open.
export function requestNotifyPermission() {
  try {
    if ("Notification" in window && Notification.permission === "default") {
      Notification.requestPermission();
    }
  } catch { /* ignore */ }
}

export function pushBrowserNotification(title, body) {
  try {
    if ("Notification" in window && Notification.permission === "granted") {
      const n = new Notification(title, { body, tag: "dox" });
      setTimeout(() => n.close(), 8000);
    }
  } catch { /* ignore */ }
}
